import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../index'

interface SessionExpirationState {
  isExpired: boolean
  shouldShowModal: boolean
  shouldRedirectToLogin: boolean
}

const initialState: SessionExpirationState = {
  isExpired: false,
  shouldShowModal: false,
  shouldRedirectToLogin: false,
}

const sessionExpirationSlice = createSlice({
  name: 'sessionExpiration',
  initialState,
  reducers: {
    setExpired(state, action: PayloadAction<{ shouldShowModal: boolean }>) {
      state.isExpired = true
      state.shouldShowModal = action.payload.shouldShowModal
      state.shouldRedirectToLogin = true
    },
    markLoginRedirectHandled(state) {
      state.shouldRedirectToLogin = false
    },
    hideSessionExpiredModal(state) {
      state.shouldShowModal = false
    },
  },
})

export const selectIsSessionExpired = (state: RootState) =>
  state.sessionExpiration.isExpired
export const selectShouldShowSessionExpiredModal = (state: RootState) =>
  state.sessionExpiration.shouldShowModal
export const selectShouldRedirectToLogin = (state: RootState) =>
  state.sessionExpiration.shouldRedirectToLogin

export const { setExpired, markLoginRedirectHandled, hideSessionExpiredModal } = sessionExpirationSlice.actions
export default sessionExpirationSlice.reducer
